import React, { useEffect, useState } from "react";
//import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { BiFace } from "react-icons/bi";
import { Label, Hint, Error } from "@progress/kendo-react-labels";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
//import { Link, NavLink, useLocation } from "react-router-dom";
import { useNavigate, useParams, Link } from "react-router-dom";
import logo from "../../assets/img/logo.png";
import Footer from "../common/Footer/Footer";
const AuthLogin = () => {
  /* get REACT_APP_API_URL from .env file */
  const { REACT_APP_BASE_URL } = process.env;
  const { REACT_APP_API_URL } = process.env;
  const { REACT_APP_CookieURL } = process.env;
  const { REACT_APP_ANALYTICS_BASE_URL, REACT_APP_WEBSITE_URL } = process.env;

  const { register, handleSubmit, formState: { errors } } = useForm({ mode: "onTouched" });

  const { companyName } = useParams() || "";
  /* get values from URL parameters */
  const { surveyId } = useParams() || "";
  const [loading, setLoading] = useState(false);
  const [pinValue, setPinValue] = useState();
  /* variable declarations */
  let history = useNavigate();

  const [toggleSuccess, setToggleSuccess] = useState("");
  const [toggleError, setToggleError] = useState("");

  const onToggleSuccess = (message) => {
    setToggleSuccess(message);
    if (message != "") {
      setTimeout(() => {
        setToggleSuccess("");
      }, 4000);
    }
  };

  const onToggleError = (message) => {
    setToggleError(message);
    if (message != "") {
      setTimeout(() => {
        setToggleError("");
      }, 4000);
    }
  };

  /* slide method declare in parent */
  const next = () => {
    setLoading(true);
    if (pinValue == "261092") {
      fastLogin();
    } else {
      onToggleError("The PIN you have entered is invalid");
      setLoading(false);
    }
  };

  const getUserData = async (token) => {
    /* get user data */
    await axios
      .get(`${REACT_APP_API_URL}/user`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((result) => {
        if (result.data.data) {
          localStorage.setItem("user", window.btoa(JSON.stringify(result.data.data)));
        } else {
          onToggleError(404, "No data found.");
        }
      })
      .catch((err) => {
        onToggleError(404, "Something went wrong.");
      });
  };

  const fastLogin = () => {
    axios
      .post(`${REACT_APP_API_URL}/AnalyticsLogin`, { survey_id: surveyId })
      .then(async (result) => {
        if (result.status) {
          await getUserData(result.data.access_token, true);
          sessionStorage.setItem("analytics_token", result.data.access_token);
          window.location = `${REACT_APP_ANALYTICS_BASE_URL}/${companyName}/Analytics/${surveyId}`;
        }
      })
      .catch((err) => {
        if (err.response) {
          onToggleError(404, "invalid credentials");
          // } else if (err.request) {
          //   Error(err.request.status, err.request.data.message);
        } else {
          onToggleError(404, "Something went wrong.");
        }
      });
  };

  useEffect(() => { }, [history, REACT_APP_API_URL, REACT_APP_BASE_URL, surveyId, companyName]);

  return (
    <>
      <div className="header bg-white border-bottom">
        <Container fluid>
          <div className="header-inner d-flex justify-content-between align-items-center">
            <div className="header-logo">
              <Link to={{ pathname: `${REACT_APP_WEBSITE_URL}` }} target={"_blank"}>
                <img src={logo} alt="logo" className="nav-logo" />
              </Link>
            </div>
            <div className="header_title">
              <h3>OpenEyes Surveys Analytics</h3>
            </div>
          </div>
        </Container>
      </div>
      <div className="login-reg-main text-center">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="form-account bg-white shadow-sm">
                <h4>Login</h4>
                <p className="common_head_desc">Login with registered PIN number to go to survey analytics page</p>
                <form onSubmit={handleSubmit(next)}>
                  {loading ? (
                    <center className="p-5 m-5">
                      <Spinner animation="border" as="span" variant="info" style={{ height: 100, width: 100 }} />
                      <h5 className="pt-5">Please wait...</h5>
                    </center>
                  ) : (
                    <>
                      <div className="form-input-main">
                        <label className="form-label" htmlFor="floatingInput">
                          <span className="me-1">*</span>Login with 6-digit PIN number
                        </label>
                        <input
                          name="pinNumber"
                          autoComplete="off"
                          id="floatingInput"
                          type="text"
                          className="form-control"
                          placeholder="Enter your PIN number"
                          maxLength="6"
                          {...register('pinNumber', {
                            required: true,
                            pattern: /^[0-9]+$/i,
                            minLength: 6,
                            maxLength: 6,
                          })}
                          onChange={(e) => {
                            setPinValue(e.target.value);
                          }}
                        />
                        {errors.pinNumber && errors.pinNumber.type === "required" && (
                          <p className="text-danger text-start">Pin number is required.</p>
                        )}
                        {errors.pinNumber && errors.pinNumber.type === "pattern" && (
                          <p className="text-danger text-start">Please enter valid PIN Number.</p>
                        )}
                        {errors.pinNumber && errors.pinNumber.type === "minLength" && (
                          <p className="text-danger text-start">Please enter valid PIN Number.</p>
                        )}
                        {errors.pinNumber && errors.pinNumber.type === "maxLength" && (
                          <p className="text-danger text-start">Please enter valid PIN Number.</p>
                        )}
                      </div>

                      <div className="" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <button className="btn-grad btn-grad-blue" type="submit">
                          Access Now
                        </button>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {/* <div>
        <div className="header bg-white border-bottom">
          <Container fluid>
            <div className="header-inner d-flex justify-content-between">
              <div className="header-logo">
                <Link to={{ pathname: `${REACT_APP_WEBSITE_URL}` }} target={"_blank"}>
                  <img src={logo} alt="logo" className="nav-logo" />
                </Link>
              </div>
            </div>
          </Container>
        </div>
        <div className="min-height container">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="page-not-found-message">
                  <div className="error-icon">
                    <BiFace />
                  </div>
                  <h4>Survey</h4>
                  <h5>Analytics Fast Access</h5>

                  <form onSubmit={handleSubmit(next)}>
                    {loading ? (
                      <center className="p-5 m-5">
                        <Spinner animation="border" as="span" variant="info" style={{ height: 100, width: 100 }} />
                        <h4 className="pt-5">Loading...</h4>
                      </center>
                    ) : (
                      <>
                        <div className="form-input-main">
                          <label className="form-label">
                            <span className="me-1">*</span>Access Pin Number
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            name="pinNumber"
                            maxLength="6"
                            tabIndex="1"
                            placeholder="Enter your pin number"
                            className="form-control"
                            ref={register({
                              required: true,
                              pattern: /^[0-9]+$/i,
                              minLength: 6,
                              maxLength: 6,
                            })}
                            onChange={(e) => {
                              setPinValue(e.target.value);
                            }}
                          />
                          {errors.pinNumber && errors.pinNumber.type === "required" && (
                            <p className="text-danger text-start">Pin number is required.</p>
                          )}
                          {errors.pinNumber && errors.pinNumber.type === "pattern" && (
                            <p className="text-danger text-start">Please enter valid pin number.</p>
                          )}
                          {errors.pinNumber && errors.pinNumber.type === "minLength" && (
                            <p className="text-danger text-start">Please enter valid pin number.</p>
                          )}
                          {errors.pinNumber && errors.pinNumber.type === "maxLength" && (
                            <p className="text-danger text-start">Please enter valid pin number.</p>
                          )}
                        </div>

                        <div
                          className="previous-next my-3"
                          style={{ alignItems: "center", justifyContent: "space-between" }}>
                          <button className="btn-grad btn-grad-blue" type="submit">
                            Access Now
                          </button>
                        </div>
                      </>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div> */}

      {toggleSuccess != "" ? (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {toggleSuccess}
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      ) : (
        <></>
      )}

      {toggleError != "" ? (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {toggleError}
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default AuthLogin;
